/* RESPONSIBLE TEAM: team-actions */
import type AppService from 'embercom/services/app-service';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import type SetupAction from 'embercom/models/workflow-connector/setup-action';
import type McpServer from 'embercom/models/workflow-connector/mcp-server';
import type ArrayProxy from '@ember/array/proxy';
import { ReactRoute } from 'embercom/lib/react-route';
import type Transition from '@ember/routing/transition';

const REQUIRED_PERMISSION = 'can_access_developer_hub';

class CustomActions extends SettingsRoute {
  @service declare store;
  @service declare appService: AppService;
  @service declare intercomEventService;
  @service declare permissionsService: $TSFixMe;
  @service declare intl: IntlService;

  analytics = {
    section: 'settings',
    place: 'action-builder',
  };

  get titleToken() {
    return this.intl.t('new-settings.app-settings.custom-actions.action-builder-title');
  }

  beforeModel(transition: Transition) {
    if (!this.permissionsService.currentAdminCan(REQUIRED_PERMISSION)) {
      transition.abort();
      this.permissionsService.loadAllAdminsAndShowPermissionRequestModal(REQUIRED_PERMISSION);
    }
  }

  // Enable React rendering when feature flag is on
  reactEnabled() {
    return this.appService.app.canUseFeature('data-connectors-react-list-page');
  }

  async model() {
    // If React is enabled, skip Ember model loading (React will handle it)
    if (this.reactEnabled()) {
      return null;
    }
    let actions: ArrayProxy<SetupAction> = await this.store.findAll(
      'workflow-connector/setup-action',
    );
    let mcpServers: ArrayProxy<McpServer> = await this.store.findAll(
      'workflow-connector/mcp-server',
    );

    if (!actions) {
      return {
        actions: [],
        templateActions: [],
        mcpServers,
      };
    }

    let workflowActions = actions.filterBy('isTemplate', false);
    let templateActions = actions.filterBy('isTemplate', true);

    return {
      actions: workflowActions,
      templateActions,
      mcpServers,
    };
  }

  @action
  didTransition() {
    super.didTransition();
    this.intercomEventService.trackEvent('has_visited_custom_actions');
  }
}

// Wrap with ReactRoute to enable React Island rendering
export default ReactRoute(CustomActions);
